
<ng-container *ngIf="!(breakpointObserve$ | async)?.matches; else icon">
  <button [ngClass]="{open:isOpenExport}" class="btn-secondary registry-button" (click)="isOpenExport = !isOpenExport" cdkOverlayOrigin #sortingTrigger="cdkOverlayOrigin">
    <span class="caption-2"> {{ 'DATA.TABLE.EXPORT_REGISTRY' | translate }} </span>
  </button>


  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayOrigin]="sortingTrigger"
    [cdkConnectedOverlayOpen]="isOpenExport"
    (backdropClick)="isOpenExport = !isOpenExport"
  >
    <app-registry-export-modal (menuClose)="isOpenExport = !$event"></app-registry-export-modal>


  </ng-template>

</ng-container>




<ng-template #icon>
  <button [matTooltip]="'DATA.TABLE.EXPORT_REGISTRY' | translate" class="btn-empty download-icon" type="button" (click)="isOpenExport = !isOpenExport" cdkOverlayOrigin #sortingTrigger="cdkOverlayOrigin">
    <svg [icon]="icons.Downloaded" class="svg24" />
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayOrigin]="sortingTrigger"
    [cdkConnectedOverlayOpen]="isOpenExport"
    [cdkConnectedOverlayPositions]="cdkPosition"
    (backdropClick)="isOpenExport = !isOpenExport"
  >
    <app-registry-export-modal (menuClose)="isOpenExport = !$event"></app-registry-export-modal>

  </ng-template>
</ng-template>

